import Vue from 'vue';
import {pageScroll} from '../../../assets/utils';
import ToastTpl from './ToastTpl';

const ConfirmConstructor = Vue.extend(ToastTpl);

const instance = new ConfirmConstructor({
  el: document.createElement('div')
});

ConfirmConstructor.prototype.closeToast = function closeToast() {
  const el = instance.$el;
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
  pageScroll.unlock();
  if (typeof this.callback === 'function') {
    this.callback();
  }
};

const Toast = (options = {}) => {
  instance.mes = options.mes;
  instance.icon = options.icon;
  instance.timeout = options.timeout || 2000;
  instance.callback = options.callback;

  document.body.appendChild(instance.$el);

  pageScroll.lock();

  const timer = setTimeout(() => {
    clearTimeout(timer);
    instance.closeToast();
  }, instance.timeout + 100);
};

export default Toast;
export {Toast};



// WEBPACK FOOTER //
// ./src/components/Dialog/toast/index.js